import React from 'react';
var _ref2 = /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#788590",
  d: "M12 2L1 21h22"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 6l7.53 13H4.47L12 6zm1 10h-2v2h2v-2zm0-6h-2v4h2v-4z",
  fill: "#CED4D9"
})));
function WarningOutlineTwoToned(_ref) {
  let {
    color = '#335B70',
    ...props
  } = _ref;
  return _ref2;
}
export default WarningOutlineTwoToned;